import React from "react";
import "./Loader.css";

interface LoaderProps {
  inline?: boolean; // if true, loader is shown inside a div
  circular?: boolean; // if true, shows a circular spinner instead of dots
}

const Loader: React.FC<LoaderProps> = ({ inline = false, circular = false }) => {
  if (circular) {
    return (
      <div className={inline ? "loader-inline" : "loader-overlay"}>
        <div className="loader-spinner" />
      </div>
    );
  }
  return (
    <div className={inline ? "loader-inline" : "loader-overlay"}>
      <div className="loader">
        <div className="dot dot1"></div>
        <div className="dot dot2"></div>
        <div className="dot dot3"></div>
      </div>
    </div>
  );
};

export default Loader;
